<template>
  <div>
    <div class="div-form">
      <Messages />
      <div v-if="!showSuccess">
        <div class="div-title">
          <span class="title-forgot">Redefinir Senha</span>
        </div>
        <b-row>
          <b-col sm="12">
            <InputPassword title="Nova Senha" field="password" :formName="formName" :required="true" :maxLength="50"
              v-model="forgot.password">
              <div class="glyphicon">
                <i class="fas fa-lock"></i>
              </div>
            </InputPassword>
          </b-col>
          <b-col sm="12">
            <InputPassword title="Confirme Nova Senha" field="password" :formName="formName" :required="true"
              :maxLength="50" v-model="forgot.confirmPassword">
              <div class="glyphicon">
                <i class="fas fa-lock"></i>
              </div>
            </InputPassword>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <div class="div-btn">
              <Button _key="save" type="success" title="Salvar" :disabled="disabled" classIcon="fa-solid fa-floppy-disk"
                size="medium" :clicked="save" />
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="!showSuccess" @click="navegateToLogin()" class="text-center div-forgot-password">
        Voltar para o login
      </div>
      <div class="text-center" v-if="showSuccess">
        <div class="reset-success-subtitle title">
          Senha redefinida com sucesso!
        </div>
        <div class="reset-success-icon">
          <i class="fa-light fa-circle-check"></i>
        </div>
        <Timer :title="'Redirecionando para o Login em'" :initialTimer="5" :endTime="navegateToLogin" />
      </div>
    </div>
  </div>
</template>
<script>
import InputPassword from "@nixweb/nixloc-ui/src/component/forms/InputPassword";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Messages from "@nixweb/nixloc-ui/src/component/shared/Messages.vue";
import Timer from "@nixweb/nixloc-ui/src/component/shared/Timer";

import ForgotPassword from "@/components/modules/adm/login/ForgotPassword.js";

import { mapActions, mapMutations } from "vuex";

export default {
  name: "ResetPassword",
  components: { InputPassword, Button, Messages, Timer },
  data() {
    return {
      formName: "forgot",
      forgot: new ForgotPassword(),
      urlReset: "api/v1/adm/auth/reset-password",
      showSuccess: false,
    };
  },
  computed: {
    disabled() {
      if (
        this.forgot.password == this.forgot.confirmPassword &&
        this.forgot.password
      )
        return false;

      return true;
    },
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["removeLoading"]),
    save() {
      let obj = {
        codeResetPassword: this.$route.params.code,
        password: this.forgot.password,
      };
      let params = { url: this.urlReset, obj: obj };
      this.postApi(params).then((response) => {
        setTimeout(() => {
          if (response.success) {
            this.showSuccess = true;
          }
          this.removeLoading(["save"]);
        }, 2000);
      });
    },
    navegateToLogin() {
      this.$router.replace(this.$route.query.redirect || "/login");
    }
  },
};
</script>
<style scoped>
.div-form {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 30px;
}

.div-title {
  margin-bottom: 30px;
}

.div-btn {
  margin-top: 20px;
}

.title-forgot {
  font-size: 25px;
}

.title-rodape {
  font-size: 13px;
}

.icon-whatsapp {
  color: green;
}

.reset-success-icon i {
  font-size: 50px;
  color: #16a34a;
  margin-bottom: 15px;
}

.reset-success-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}

.reset-success-subtitle {
  font-size: 18px;
  margin-bottom: 25px;
}

.div-forgot-password {
  margin-top: 15px;
  margin-bottom: 5px;
  cursor: pointer;
  color: #4680a5;
}
</style>
